import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';

const NotFoundPage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-700 flex items-center justify-center p-4">
      <motion.div 
        className="bg-black bg-opacity-60 backdrop-filter backdrop-blur-lg p-8 rounded-xl max-w-md w-full text-center"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <motion.h1 
          className="text-6xl font-bold text-blue-500 mb-4"
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ 
            type: "spring",
            stiffness: 200,
            damping: 10
          }}
        >
          404
        </motion.h1>
        
        <h2 className="text-2xl text-white font-bold mb-2">Page Not Found</h2>
        <p className="text-blue-300 mb-6">The summoner you're looking for seems to be in another rift.</p>
        
        <motion.button
          onClick={() => navigate('/')}
          className="py-2 px-6 bg-blue-600 text-white rounded-lg hover:bg-blue-500 transition duration-300 flex items-center gap-2 mx-auto"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaHome />
          Return to Home
        </motion.button>
      </motion.div>
    </div>
  );
};

export default NotFoundPage;